import { MergeKeyService } from './../../services/merge-key.service';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { Component, DestroyRef, Injector, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { deepCopy, getDataScopeByPermission, getRoleScopeColumnMappings, getForwarderByPermission, isNullOrEmpty, laaSFormatString } from 'src/app/core/utils/common-functions';
import { BookingService } from '../../services/booking.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { MenuItem } from 'primeng/api';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { FacilityService } from 'src/app/core/services/facility.service';
import { WarehousingSearchService } from '../../services/warehousing-search.service';
import { Dropdown } from 'primeng/dropdown';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import * as xlsx from 'xlsx';
import { DatePipe } from '@angular/common';
import { ImportSourceType } from 'src/app/core/enums/import-source-type.enum';
import { LaasOption } from 'src/app/core/models/laas-option';
import { CancelWarehousingDetailRequest } from 'src/app/core/models/transport-operation/cancel-warehousing-detail-request';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { AddWarehousingAbnormalRequest } from 'src/app/core/models/transport-operation/add-warehousing-abnormal-request';
import { WarehousingAbnormalType } from 'src/app/core/enums/warehousing-abnormal-type.enum';
import { ActivatedRoute, Params } from '@angular/router';
import { WarehousingAbnormalService } from '../../services/warehousing-abnormal.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { finalize } from 'rxjs/operators';
import { ImportWarehousingDetailResp } from './dto/warehousing-detail';

enum HawbNoVerificationStatusCode {
  AD_NOT_FOUND_CODE = 1,
  NON_UNIQUE_BILL_OF_LADING_CODE = 2,
  HAWB_NO_AND_BILL_OF_LADING_MISMATCH_CODE = 3
}

interface HawbNoVerificationResult {
  warningMessage: string;
  equalStatus: boolean;
  statusCode: HawbNoVerificationStatusCode;
}

@Component({
  selector: 'laas-warehousing-search',
  templateUrl: './warehousing-search.component.html',
  styleUrls: ['./warehousing-search.component.scss']
})


export class WarehousingSearchComponent extends SessionBaseComponent implements OnInit {


  readonly preferenceKey: string;
  readonly preferenceKey2: string;
  readonly permissionCode = PermissionConstants.ViewWarehousingSearch;
  @ViewChild('receiptFormDate') receiptFormDate!: CalendarComponent;
  @ViewChild('receivingDate') receivingDate!: CalendarComponent;
  @ViewChild('checkInDate') checkInDate!: CalendarComponent;
  @ViewChild('flightDate') flightDate!: CalendarComponent;
  @ViewChild('declarationDate') declarationDate!: CalendarComponent;

  isLoadingImportDetail: boolean = false;
  isSearchFormOpen: boolean = true;
  searchForm: FormGroup;
  importForm!: FormGroup;
  importDropShipForm!: FormGroup;
  importDetailParams: any;
  importDropShipParams: any;
  searchParams: any;
  isLoading: boolean = false;
  deliveryOptions: any[] = [];
  whDocStatusOptions: any[] = [];
  shipTermOptions: LaasOption[] = [];
  bookingForwarderOptions: any[] = [];
  countryOptions: any[] = [];
  docTypeOptions: any[] = [];
  importTypeOptions: any[] = [];
  whDetailStatusOptions: any[] = [];
  brandOptions: any[] = [];
  letterHeadOptions: any[] = [];
  pickupLocationOptions: any[] = [];
  shipMethodOptions: any[] = [];
  priorityOptions: any[] = [];
  yesNoOption: any[] = [];
  allCityOptions: any[] = [];
  allAreaOptions: any[] = [];
  billCorpOptions: any[] = [];
  billObjectTypeOptions: any[] = [];
  billObjectOptions: any[] = [];
  vendorOptions: any[] = [];
  isActivatedOptions: any[] = [];
  searchResults: any[] = [];
  detailColumns: any[] = [];
  sourceTypeList: any[] = [];
  brandList: any[] = [];
  deliverySubTypeOptions: any[] = [];
  columns: any[];
  isShowReceiptFormDownloadBtn: boolean = false;
  isShowGETsDownloadBtn: boolean = false;
  isShowBatchUpdateBtn: boolean = false;
  isShowAssignModal: boolean = false;
  isShowCopyModal: boolean = false;
  isShowImportModal: boolean = false;
  isShowImportDropShipModal: boolean = false;
  isShowDetailModal: boolean = false;
  importSubmitted: boolean = false;
  importDropShipSubmitted: boolean = false;
  isLoadingImportDropShip: boolean = false;
  importEvent: any;
  bookingInfo: any;
  isGenerateFeeOptions: any[] = [];
  isFeeCalculationOptions: any[] = [];

  isShowUpdateBondedNoModal: boolean = false;
  urgentFlagOptions: any[] = [];

  selectedSeqNo: any[] = [];
  assignWarehousingParams: any;
  facilityOptions: any[] = [];
  clickWhNo: string = "";
  seqNoList: any[] = [];
  mainItemMenus: MenuItem[];

  itemMenus: MenuItem[];

  //file Management
  showDoFile: boolean;
  showDoPodFile: boolean;
  whNoFile: string;
  whNoFileList: { doNo: string, fileType: string }[] = [];
  isShowBillingViewerModal: boolean;
  isShowBillingPreviewCalculateViewerModal: boolean;
  isShowRemainingSkuModal: boolean;
  bookingNoFile: any;
  bookingNoPreviewCalculate: any;
  remainingSkuWhNo: any;

  advanced: any;
  download: any;
  revisionCustomsUnitPrice: any;
  downloadRFQ: any;
  generateTaxPayment: any;
  printReceipt: any;
  import: any;
  importDropDO: any;
  cost = '';
  costReview: any;
  generateCostReport = '';
  assignGenerateReceipt: any;
  copyReciptForm: any;
  uploadAttachment: any;
  warehousingDetailAbnormal: any;
  rfCheckedNoAd: any;
  remainingSku: any;

  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "whNo",
    direction: -1
  };

  isRwd: boolean = false;
  currentLang: string = this.laasSetting.language;
  @ViewChild("table") table!: DataTableComponent;

  existedAdNoOptions: any[] = [];
  alreadynotifiedOptions: any[] = [];
  alreadyUploadedOptions: any[] = [];
  shippingProcessedRemainingOptions: any[] = [];
  pcsrProcessedRemainingOptions: any[] = [];
  carTypeOptions: any[] = [];

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private bookingService: BookingService,
    private dOService: DeliveryOrderService,
    private commonDataService: CommonDataService,
    private warehousingSearchService: WarehousingSearchService,
    private warehousingAbnormalService: WarehousingAbnormalService,
    private dropdownOptionsService: DropdownOptionsService,
    private mergeKeyService: MergeKeyService,
    private menuDataService: MenuService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private destroyRef: DestroyRef
  ) {

    super(injector);

    this.preferenceKey = UserPreferenceConstants.WarehousingSearchMain;
    this.preferenceKey2 = UserPreferenceConstants.WarehousingSearchDetail;

    this.showDoFile = false;
    this.showDoPodFile = false;
    this.whNoFile = "";
    this.isShowBillingViewerModal = false;
    this.isShowBillingPreviewCalculateViewerModal = false;
    this.isShowRemainingSkuModal = false;

    this.searchParams = {
      whNoList: [],
      importDeclarationNoList: [],
      deliveryTypeList: [],
      whStatusList: [],
      shipTermList: [],
      shipperList: [],
      vendorCustomer: null,
      fromCountryList: [],
      docTypeList: [],
      docNo: [],
      importTypeList: [],
      addressCodeList: [],
      shippingMethodList: [],
      orgIdList: [],
      bondedNoList: [],
      crossBoundryNoList: [],
      startCreateDt: null,
      endCreateDt: null,
      startWhDt: null,
      endWhDt: null,
      startRfCheckDt: null,
      endRfCheckDt: null,
      startFlightDt: null,
      endFlightDt: null,
      startImportDt: null,
      endImportDt: null,
      brand: null,
      hawbNoList: null,
      mawbNo: null,
      applyNo: null,
      originWhNo: null,
      referenceKey: null,
      isGenerateFee: null,
      createUser: null,
      isFeeCalculation: null,
      existedAdNoFlag: null,
      alreadyNotifiedFlag: null,
      alreadyUploadedFlag: null,
      shippingProcessedRemainingFlag: null,
      pcsrProcessedRemainingFlag: null,
      uom: null,
      facilityList: [this.laasSetting.facility]
    };

    this.searchForm = this.fb.group({
      whNoList: [],
      importDeclarationNoList: [],
      deliveryTypeList: [],
      whStatusList: [],
      shipTermList: [],
      shipperList: [],
      vendorCustomer: null,
      fromCountryList: [],
      docTypeList: [],
      docNo: [],
      importTypeList: [],
      addressCodeList: [],
      shippingMethodList: [],
      orgIdList: [],
      bondedNoList: [],
      crossBoundryNoList: [],
      startCreateDt: null,
      endCreateDt: null,
      startWhDt: null,
      endWhDt: null,
      startRfCheckDt: null,
      endRfCheckDt: null,
      startFlightDt: null,
      endFlightDt: null,
      startImportDt: null,
      endImportDt: null,
      brand: null,
      hawbNoList: null,
      mawbNo: null,
      applyNo: null,
      originWhNo: null,
      referenceKey: null,
      isGenerateFee: null,
      createUser: null,
      isFeeCalculation: null,
      existedAdNoFlag: null,
      alreadyNotifiedFlag: null,
      alreadyUploadedFlag: null,
      shippingProcessedRemainingFlag: null,
      pcsrProcessedRemainingFlag: null,
      uom: null,
      facilityList: [[this.laasSetting.facility]]
    });


    this.columns = [
      { field: 'isPrint', header: 'ReceiptForm.MainTable.IsPrinted', sort: true },
      { field: 'facility', header: 'ReceiptForm.MainTable.Facility', sort: true },
      { field: 'whNo', header: 'ReceiptForm.MainTable.ReceiptFormNum', sort: true },
      { field: 'originWhNo', header: 'ReceiptForm.MainTable.OriginalReceiptForm', sort: true },
      { field: 'orgId', header: 'ReceiptForm.MainTable.Company', sort: true },
      { field: 'billCorp', header: 'ReceiptForm.MainTable.ChargeBackCompany', sort: true },
      { field: 'deliveryType', header: 'ReceiptForm.MainTable.DocumentType', sort: true },
      { field: 'importDeclarationNo', header: 'ReceiptForm.MainTable.ImportDeclarationNum', sort: true },
      { field: 'urgentFlag', header: 'ReceiptForm.MainTable.IsUrgent', sort: true },
      { field: 'isGenerateFee', header: 'ReceiptForm.MainTable.GenerateExpenses', sort: true },
      { field: 'importAmount', header: 'ReceiptForm.MainTable.CustomsDeclarationAnt', sort: true },
      { field: 'whStatus', header: 'ReceiptForm.MainTable.ReceiptFormStatus', sort: true },
      { field: 'shipTerm', header: 'ReceiptForm.MainTable.TradeTerm', sort: true },
      { field: 'shipper', header: 'ReceiptForm.MainTable.Forwarder', sort: true },
      { field: 'vendorCustomerName', header: 'ReceiptForm.MainTable.Supplier', sort: true },
      { field: 'whDt', header: 'ReceiptForm.MainTable.ReceivingTime', dataType: 'date', sort: true },
      { field: 'expectedDt', header: 'ReceiptForm.MainTable.EstimateArrivalDay', dataType: 'date', sort: true },
      { field: 'hawbNo', header: 'ReceiptForm.MainTable.HAWB', sort: true },
      { field: 'fromCountry', header: 'ReceiptForm.MainTable.OriginCountry', sort: true },
      { field: 'fromCity', header: 'ReceiptForm.MainTable.OriginCity', sort: true },
      { field: 'fromArea', header: 'ReceiptForm.MainTable.OriginArea', sort: true },
      { field: 'palletCnt', header: 'ReceiptForm.MainTable.NumberPallets', sort: true },
      { field: 'totalCartonCnt', header: 'ReceiptForm.MainTable.TotalCartonCnt', sort: true },
      { field: 'totalChargeableWeight', header: 'ReceiptForm.MainTable.TotalChargeableWeight', sort: true },
      { field: 'totalGrossWeight', header: 'ReceiptForm.MainTable.TotalGrossWeight', sort: true },
      { field: 'totalVolumeWeight', header: 'ReceiptForm.MainTable.TotalVolumeWeight', sort: true },
      { field: 'totalQty', header: 'ReceiptForm.MainTable.TotalQty', sort: true },
      { field: 'rfCaseCnt', header: 'ReceiptForm.MainTable.NumofCartonsReceived', sort: true },
      { field: 'qtyReceived', header: 'ReceiptForm.MainTable.ActualQty', sort: true },
      { field: 'brand', header: 'ReceiptForm.MainTable.Brand', sort: true },
      { field: 'addressCode', header: 'ReceiptForm.MainTable.WarehouseAddress', sort: true },
      { field: 'hawbFile', header: 'ReceiptForm.MainTable.ImportDeclaration', sort: true },
      { field: 'invoiceFile', header: 'ReceiptForm.MainTable.InvoiceWaybill', sort: true },
      { field: 'flightNo', header: 'ReceiptForm.MainTable.FlightNum', sort: true },
      { field: 'flightDt', header: 'ReceiptForm.MainTable.FlightDate', dataType: 'date', sort: true },
      { field: 'createDt', header: 'ReceiptForm.MainTable.CreationTime', dataType: 'date', sort: true },
      { field: 'updateDt', header: 'ReceiptForm.MainTable.EditTime', dataType: 'date', sort: true },
      { field: 'toCountry', header: 'ReceiptForm.MainTable.ToCountry', sort: true },
      { field: 'toArea', header: 'ReceiptForm.MainTable.ToArea', sort: true },
      { field: 'toCity', header: 'ReceiptForm.MainTable.ToCity', sort: true },
      { field: 'deliverySubType', header: 'ReceiptForm.MainTable.DeliverySubType', sort: true },
      { field: 'splitDept', header: 'ReceiptForm.MainTable.SplitDept', sort: true },
      { field: 'permitType', header: 'ReceiptForm.MainTable.PermitType', sort: true },
      { field: 'isDropShipment', header: 'ReceiptForm.MainTable.IsDropShipment', sort: true },
      { field: 'employCode', header: 'ReceiptForm.MainTable.EmployCode', sort: true },
      { field: 'isFeeCalculation', header: 'ReceiptForm.MainTable.IsFeeCalculation', sort: true },
      { field: 'bulkCargoNo', header: 'ReceiptForm.MainTable.BulkCargoNo', sort: true },
      { field: 'bulkCargoNoLocation', header: 'ReceiptForm.MainTable.BulkCargoNoLocation', sort: true },
      { field: 'isHaveAd', header: 'ReceiptForm.MainTable.IsHaveAd', sort: true },
      { field: 'isNotified', header: 'ReceiptForm.MainTable.IsNotified', sort: true },
      { field: 'isHaveDoc', header: 'ReceiptForm.MainTable.IsHaveDoc', sort: true },
      { field: 'isPcsrHandled', header: 'ReceiptForm.MainTable.IsPcsrHandled', sort: true },
      { field: 'isShippingHandled', header: 'ReceiptForm.MainTable.IsShippingHandled', sort: true },
      { field: 'uom', header: 'ReceiptForm.MainTable.CalculationUnit', sort: true },
      { field: 'consolidationForwarder', header: 'ReceiptForm.MainTable.ConsolidationForwarder', sort: true },
      { field: 'crossBoundryForwarder', header: 'ReceiptForm.MainTable.CrossBoundryForwarder', sort: true },
      { field: 'crossBoundryNo', header: 'ReceiptForm.MainTable.CrossBoundryNo', sort: true },
      { field: 'billObjectType', header: 'ReceiptForm.MainTable.PayeeType', sort: true },
      { field: 'billObject', header: 'ReceiptForm.MainTable.Payee', sort: true },
      { field: 'shippingMethod', header: 'ReceiptForm.MainTable.ShippingMethod', sort: true },
      { field: 'bondedNo', header: 'ReceiptForm.MainTable.BondedNo', sort: true },
      { field: 'consolidationFromCountry', header: 'ReceiptForm.MainTable.ConsolidationFromCountry', sort: true },
      { field: 'consolidationFromCity', header: 'ReceiptForm.MainTable.ConsolidationFromCity', sort: true },
      { field: 'consolidationFromArea', header: 'ReceiptForm.MainTable.ConsolidationFromArea', sort: true },
      { field: 'consolidationToCountry', header: 'ReceiptForm.MainTable.ConsolidationToCountry', sort: true },
      { field: 'consolidationToCity', header: 'ReceiptForm.MainTable.ConsolidationToCity', sort: true },
      { field: 'consolidationToArea', header: 'ReceiptForm.MainTable.ConsolidationToArea', sort: true }
    ];


    this.detailColumns = [
      { field: '__delete', header: 'ReceiptForm.SubTable.Delete', sort: false },
      { field: 'facility', header: 'ReceiptForm.SubTable.Facility', sort: true },
      { field: 'whNo', header: 'ReceiptForm.SubTable.ReceiptFormNum', sort: true },
      { field: 'whDetailStatus', header: 'ReceiptForm.SubTable.ReceiptFormDetailStatus', sort: true },
      { field: 'orgId', header: 'ReceiptForm.SubTable.Company', sort: true },
      { field: 'sourceType', header: 'ReceiptForm.SubTable.DocumentSource', sort: true },
      { field: 'referenceKey', header: 'ReceiptForm.SubTable.ReceiptNum', sort: true },
      { field: 'trxDt', header: 'ReceiptForm.SubTable.DocumentDate', dataType: 'date', sort: true },
      { field: 'amount', header: 'ReceiptForm.SubTable.DocumentAnt', sort: true },
      { field: 'brand', header: 'ReceiptForm.SubTable.Brand', sort: true },
      { field: 'pcsrName', header: 'ReceiptForm.SubTable.PCSRName', sort: true },
      { field: 'pcsrDept', header: 'ReceiptForm.SubTable.PCSRDept', sort: true },
      { field: 'assignDept', header: 'ReceiptForm.SubTable.AssignDept', sort: true },
      { field: 'invoiceNo', header: 'ReceiptForm.SubTable.InvoiceNum', sort: true },
      { field: 'bol', header: 'ReceiptForm.SubTable.AWBNum', sort: true },
      { field: 'grossWeight', header: 'ReceiptForm.SubTable.ReceivingWeight', sort: true },
      { field: 'specLocType', header: 'ReceiptForm.SubTable.WMSLocArea', sort: true },
      { field: 'referenceCode', header: 'ReceiptForm.SubTable.ReceivingType', sort: true },
      { field: 'receiptKey', header: 'ReceiptForm.SubTable.WMSReceiptSerialNum', sort: true },
      { field: 'organizationId', header: 'ReceiptForm.SubTable.OrgType', sort: true },
      { field: 'vendorId', header: 'ReceiptForm.SubTable.SupplierNN', sort: true },
      { field: 'customerId', header: 'ReceiptForm.SubTable.CustomerNN', sort: true },
      { field: 'whWmsAdFlag', header: 'ReceiptForm.SubTable.WMSTransimssionStatus', sort: true },
      { field: 'shipCorp', header: 'ReceiptForm.SubTable.ShipCorp', sort: true },
      { field: 'createDt', header: 'ReceiptForm.SubTable.CreationTime', dataType: 'date', sort: true },
      { field: 'updateDt', header: 'ReceiptForm.SubTable.EditTime', dataType: 'date', sort: true },
      { field: 'isExpenseAllocated', header: 'ReceiptForm.SubTable.IsExpenseAllocated', sort: true },
    ];

    let today = new Date();

    this.importDetailParams = {
      whNo: '',
      sourceType: "",
      referenceKey: [],
      trxDtTmp: `${today.getFullYear()}/${(today.getMonth() + 1)}/${today.getDate()}`,
      trxAmount: null,
      pcsrDept: "",
      brand: ""
    };

    this.importDropShipParams = {
      whNo: '',
      referenceKey: []
    }

    this.importForm = this.fb.group({
      sourceType: ["", Validators.required],
      referenceKey: [[], Validators.required],
      trxDtTmp: [`${(new Date()).getFullYear()}/${((new Date()).getMonth() + 1)}/${(new Date()).getDate()}`, [this.sourceTypeValidate(["3", "5", "6", "7", "Z"]).bind(this.importDetailParams.sourceType)]],
      trxAmount: [null, [this.sourceTypeValidate(["3", "5", "6", "Z"]).bind(this.importDetailParams.sourceType)]],
      pcsrDept: [""],
      brand: ["", [this.sourceTypeValidate(["3", "7"]).bind(this.importDetailParams.sourceType)]]
    });

    this.importDropShipForm = this.fb.group({
      referenceKey: [[], Validators.required]
    })
    this.translateService.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();

    this.mainItemMenus = [];

    this.itemMenus = [];

  }//end


  private sourceTypeValidate(reqiredArr: any[]) {
    return (control: FormControl) => {
      if (reqiredArr.includes(this.importDetailParams.sourceType) && isNullOrEmpty(control.value)) {
        return { required: true };
      }
      return null;
    }
  }

  translationLabel() {
    //Container Check Description
    this.advanced = this.translateService.instant('ReceiptForm.Button.Advanced')
    this.download = this.translateService.instant('ReceiptForm.Button.Download')
    this.revisionCustomsUnitPrice = this.translateService.instant('ReceiptForm.Button.RevisionCustomsUnitPrice')
    this.downloadRFQ = this.translateService.instant('ReceiptForm.Button.DownloadRFQ')
    this.generateTaxPayment = this.translateService.instant('ReceiptForm.Button.GenerateTaxPayment')
    this.printReceipt = this.translateService.instant('ReceiptForm.Button.PrintReceipt')
    this.import = this.translateService.instant('ReceiptForm.Button.Import')
    this.importDropDO = this.translateService.instant('ReceiptForm.Button.ImportDropDO')
    this.cost = this.translateService.instant('ReceiptForm.Button.Cost')
    this.costReview = this.translateService.instant('ReceiptForm.Button.CostReview')
    this.generateCostReport = this.translateService.instant('ReceiptForm.Button.GenerateCostReport')
    this.assignGenerateReceipt = this.translateService.instant('ReceiptForm.Button.AssignGenerateReceipt')
    this.copyReciptForm = this.translateService.instant('ReceiptForm.Button.CopyReciptForm')
    this.uploadAttachment = this.translateService.instant('ReceiptForm.Button.UploadAttachment')
    this.warehousingDetailAbnormal = this.translateService.instant('ReceiptForm.Button.WarehousingAbnormal')
    this.rfCheckedNoAd = this.translateService.instant('ReceiptForm.Button.RfCheckedNoAd')
    this.remainingSku = this.translateService.instant('ReceiptForm.Button.RemainingSku')

  }

  initOptions(): void {
    this.yesNoOption = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.isActivatedOptions = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.urgentFlagOptions = [
      { label: '非急單', value: '5' },
      { label: '急單', value: '1' }
    ];

    this.isGenerateFeeOptions = [
      { label: 'ALL', value: null },
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.isFeeCalculationOptions = [
      { label: 'ALL', value: null },
      { label: 'Y-已計算費用', value: 'Y' },
      { label: 'N-未計算費用', value: 'N' },
      { label: 'X-無費用', value: 'X' }
    ];

    // 單據類型
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliveryType')
      .subscribe({
        next: (options: any[]) => {
          this.deliveryOptions = options.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });

    this.dropdownOptionsService.getWhDocStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.whDocStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.getIncoTermOptions()
      .subscribe({
        next: (options: any[]) => {
          this.shipTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.getCountryOptions()
      .subscribe({
        next: (options: any[]) => {
          this.countryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));
        }
      });

    this.facilityService.getImportDocTypeOptions().subscribe({
      next: result => {
        this.docTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    // 品牌
    this.dropdownOptionsService.getBrandOptions(1)
      .subscribe({
        next: (options: any[]) => {
          this.brandOptions = options.map(x => ({ label: x.brandName, value: x.brandName }));
        }
      });

    // 公司 orgId
    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "")
      .subscribe({
        next: (options: any[]) => {

          this.letterHeadOptions = [...options].map((x: any) => {
            return {
              label: `${x.legalEntityOUCode}-${x.legalEntityOUName} ( ${x.legalEntityReferenceCode} )`,
              value: x.legalEntityOUCode,
            };
          });

          this.billCorpOptions = [...options].filter(x => x.billOUCode !== null).map((x: any) => {
            return {
              label: `${x.billOUCode}-${x.billOUName}(${x.billReferenceCode})`,
              value: x.billOUCode,
            };
          });

        }
      });

    this.dropdownOptionsService.getPickupLocationOptions(this.laasSetting.facility)
      .subscribe({
        next: (options: any[]) => {
          this.pickupLocationOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shipMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //
    this.dropdownOptionsService.getPriorityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.priorityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });


    //
    this.dropdownOptionsService.getAllCityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.allCityOptions = options.map(x => ({ label: x.name, value: x.seqNo.toString(), country: x.country }));
        }
      });

    // 區域
    this.dropdownOptionsService.getAllAreaOptionForHK()
      .subscribe({
        next: (options: any[]) => {
          this.allAreaOptions = options.map(x => ({ label: x.rfqAreaName, value: x.rfqAreaCode, citySeqNo: x.citySeqNo }));
        }
      });

    //
    this.dropdownOptionsService.getFacilityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.facilityService.getImportTypeOptions().subscribe({
      next: result => {
        this.importTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBillObjectTypeOptions().subscribe({
      next: result => {
        this.billObjectTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });

        // 依每個 billObjectType 撈出對應的 billObject options 並合併
        const requests = this.billObjectTypeOptions.map(type =>
          this.facilityService.getBillObjectOptions(this.laasSetting.facility, type.value)
        );
        forkJoin(requests).subscribe({
          next: (resultsArray: any[]) => {
            this.billObjectOptions = resultsArray.flat().map((x: any) => ({
              label: `${x.optionCode}-${x.optionDesc}`,
              value: x.optionCode,
            }));
          }
        });
      }
    });

    this.dropdownOptionsService.getWhDetailStatusOptions().subscribe({
      next: (options: any[]) => {
        this.whDetailStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));

        console.log("options:", options);
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliverySubType').subscribe({
      next: result => {
        this.deliverySubTypeOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });

      }
    });

    //計算單位 aka 車型
    this.dropdownOptionsService.getCarTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.carTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

  }

  async ngOnInit(): Promise<void> {

    await super.ngOnInit();

    this.initOptions();

    this.isShowReceiptFormDownloadBtn = this.permissionCodes.includes(PermissionConstants.BtnReceiptFormDownload);
    this.isShowGETsDownloadBtn = this.permissionCodes.includes(PermissionConstants.BtnGETsDownload);
    this.isShowBatchUpdateBtn = this.permissionCodes.includes(PermissionConstants.BtnBatchUpdate);

    // rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      // go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: result => {
        this.bookingForwarderOptions = [...result].filter(x => {
          return ( this.userProfile.userType == UserType.SuperAdmin.toString() ||
          this.userProfile.userType == UserType.Shipping.toString() ||
           getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map((x: any) => {
          return {
            label: `${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
      complete: () => {
      }
    });

    const routeData = this.routeStateService.getCurrentAndConsume()?.data;
    if (!isNullOrEmpty(routeData)) {
      this.searchParams.whNoList = routeData.whNoList;
      if (routeData.errMsgs != null && routeData.errMsgs.length > 0) {
        const msgs = routeData.errMsgs
          .reduce((str: string, msg: string, idx: number) => {
            str += `${idx + 1}. ${msg}\n`;
            return str;
          }, '');
        this.toastService.error(msgs);
      } else {
        this.searchBtnClick();
      }
    }

    //Source Type Options
    this.facilityService.getSourceTypeOptions().subscribe({
      next: result => {
        this.sourceTypeList = [...result].filter((x: any) => {
          return x.optionCode != "7"
        }).map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //Brand Options
    this.facilityService.getBrandOptions(1).subscribe({
      next: result => {
        this.brandList = [...result].map(x => {
          return {
            label: x.brandCode,
            value: x.brandName
          }
        });

        this.brandList.unshift({
          label: "請選擇",
          value: ""
        })
      }
    })

    this.dropdownOptionsService.getDocumentTypeOptionsByCategories([5])
      .subscribe({
        next: (options: any[]) => {
          this.mainItemMenus = [
            {
              label: this.advanced,
              items: [],
            },
          ];

          if (this.userProfile.userType == UserType.SuperAdmin.toString() ||
            this.permissionCodes.includes(PermissionConstants.UpdateRmbPrice)) {
            const menu = {
              label: this.revisionCustomsUnitPrice,
              command: (event: any) => {
                this.routeStateService.navigateTo('/TransportOperation/WarehousingRmbPriceImport', '');
              }
            };
            this.mainItemMenus[0].items?.push(menu);
          }

          if (this.userProfile.userType == UserType.SuperAdmin.toString() ||
            this.permissionCodes.includes(PermissionConstants.DownloadRmbPriceReport)) {
            const menu = {
              label: this.downloadRFQ,
              command: (event: any) => {
                if (this.table.selectedRows.length > 0) {
                  const whNo = this.table.selectedRows.map((x: any) => x.whNo);
                  this.warehousingSearchService.getWarehousingRMBPrice(whNo).subscribe({
                    next: (result: any[]) => {
                      if (result.length === 0) {
                        this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.NoRecordsFound'));
                        return;
                      }

                      this.exportWarehousingRMBPrice(result);
                    }
                  });
                }
              }
            };
            this.mainItemMenus[0].items?.push(menu);
          }

          if (this.userProfile.userType == UserType.SuperAdmin.toString() ||
            this.permissionCodes.includes(PermissionConstants.CreateDeclarationBooking)) {
            const menu = {
              label: this.generateTaxPayment,
              command: (event: any) => {
                if (this.table.selectedRows.length > 0) {
                  const whNo = this.table.selectedRows.map((x: any) => x.whNo);

                  var createObj = {
                    whNos: whNo,
                    userId: this.userProfile.loginAccount
                  };

                  this.loader.show();

                  this.warehousingSearchService.createBooking(createObj, this.laasSetting.facility).subscribe({
                    next: (result: any) => {
                      const success = result.bookingResults.filter((x: any) => {
                        return x.resultType == "S";
                      });

                      const generated = result.bookingResults.filter((x: any) => {
                        return x.resultType == "G";
                      });

                      const fail = result.bookingResults.filter((x: any) => {
                        return x.resultType == "E";
                      });

                      let successMsg = "";
                      let warnMsg = "";

                      if (success.length > 0) {
                        success.forEach((x: any) => {
                          successMsg += `${x.whNo} - ${x.doNo}: 成功產生完稅Booking\n`;
                        });
                      }

                      if (generated.length > 0) {
                        generated.forEach((x: any) => {
                          warnMsg += `${x.whNo} - ${x.doNo}: 已產生過完稅Booking\n`;
                        });
                      }
                      if (fail.length > 0) {
                        fail.forEach((x: any) => {
                          warnMsg += `${x.whNo} - ${x.doNo}: ${x.errorMsg}\n`;
                        });
                      }

                      if (!isNullOrEmpty(successMsg)) {
                        this.toastService.success(successMsg, true);
                      }

                      if (!isNullOrEmpty(warnMsg)) {
                        this.toastService.warn(warnMsg, true);
                      }

                    },
                    error: err => {
                      this.toastErrorMessage(err.error);
                      this.loader.hide();
                    },
                    complete: () => {
                      this.loader.hide();
                    }
                  });
                }
              }
            };
            this.mainItemMenus[0].items?.push(menu);
          }

          if (this.userProfile.userType == UserType.SuperAdmin.toString() ||
            this.permissionCodes.includes(PermissionConstants.BtnWarehousingPrint)) {
            const menu = {
              label: this.printReceipt,
              command: (event: any) => {
                this.printSelectedWarehousingPDF();
              }
            };
            this.mainItemMenus[0].items?.push(menu);
          }

          if (this.mainItemMenus[0].items?.length === 0) {
            this.mainItemMenus.shift();
          }

          if (!this.permissionCodes.includes(PermissionConstants.ViewShipImportConfirmReportForWarehousing)) {
            const index = options.findIndex(x => x.optionCode === '"ShipImportConfirmForWarehousing"');
            options.splice(index, 1);
          }

          const menuItems = options.map(x => {
            const menu = {
              label: x.optionDesc,
              state: { docType: x.optionCode },
              command: (event: any) => {
                const docType = event.item.state.docType;
                const whNoList = this.table.selectedRows.map((x: any) => x.whNo);
                const remark = "";
                this.downloadShippingDocuments(docType, 'Booking', whNoList,remark);
              }
            };
            return menu;
          });

          if (menuItems.length > 0) {
            this.mainItemMenus.push({
              label: this.download,
              items: menuItems,
            });
          }
        }
      });


    this.warehousingAbnormalDropdownList();
    this.confirmQueryParamsAndPerformAutomaticQuery();

    this.menuDataService.isRwd.subscribe(result => {
      this.isRwd = result;
    });
  }

  private confirmQueryParamsAndPerformAutomaticQuery(): void {
    this.route.queryParams.subscribe((params: Params) => {
      const paramsKeys = Object.keys(params);
      const needParams = ['whNoLinkParams', 'hawbNoLinkParams'];
      if (!needParams.some((key) => paramsKeys.includes(key))) {
        return;
      }
      if (params['whNoLinkParams']) {
        const whNos = params['whNoLinkParams'].split(';').filter((whNo: any) => !isNullOrEmpty(whNo));
        if (whNos.length > 0) {
          this.searchForm.controls["whNoList"].setValue(whNos);
        }
      }
      if (params['hawbNoLinkParams']) {
        const hawbNos = params['hawbNoLinkParams'].split(';').filter((hawNo: any) => !isNullOrEmpty(hawNo));
        if (hawbNos.length > 0) {
          this.searchForm.controls["hawbNoList"].setValue(hawbNos);
        }
      }
      console.log(`confirmQueryParamsAndPerformAutomaticQuery start searching...`);
      this.searchBtnClick();
    });
  }

  accordionTabOpen(): void {
    this.isSearchFormOpen = true;
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.table.setCurrentPage(0);
    this.searchWarehousing();
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchWarehousing();
  }

  searchBtnClick(): void {
    this.pageInfo.pageIndex = 0;
    this.table.setCurrentPage(0);
    this.searchWarehousing();
  }

  searchWarehousing(): void {
    this.isLoading = true;
    const params = deepCopy(this.searchParams);
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    params.roleScopeColumnMappings = getRoleScopeColumnMappings(this.userProfile, this.permissionCode);
    params.pageIndex = this.pageInfo.pageIndex;
    params.pageSize = this.pageInfo.pageSize;
    params.sortOrder = this.sortOrder;
    this.warehousingSearchService.searchWarehousing(params)
      .subscribe({
        next: result => {
          this.isSearchFormOpen = false;
          this.searchResults = result.content;
          // Change page Info
          this.pageInfo.totalRecords = result.totalElements;
          this.table.setPageInfo(this.pageInfo.totalRecords);
          this.isLoading = false;
        },
        error: (err: any) => {
          this.pageInfo.totalRecords = 0;
          this.table.setPageInfo(this.pageInfo.totalRecords);
          this.toastErrorMessage(err.error);
        }
      });

    this.itemMenus = [
      {
        label: this.import,
        command: (event: any) => {
          const rowData = this.table.selectedRow;
          this.openImportDetailModal(event, rowData);
        },
        visible: this.permissionCodes.includes(PermissionConstants.BtnWarehousingImportAD)
      },
      {
        label: this.importDropDO,
        command: (event: any) => {
          const rowData = this.table.selectedRow;
          this.openImportDropShipModal(event, rowData);
        },
        visible: this.permissionCodes.includes(PermissionConstants.BtnWarehousingImportDropshipment)
      },
      {
        label: this.cost,
        items: [
          {
            label: this.costReview,
            command: (event: any) => {
              const rowData = this.table.selectedRow;
              this.openBillingViewerBtn(event, rowData);
            },
            visible: this.permissionCodes.includes(PermissionConstants.BtnBillingDisplay)
          },
          {
            label: this.generateCostReport,
            command: (event: any) => {
              const rowData = this.table.selectedRow;
              this.openBillingPreviewCalculateBtn(event, rowData);
            },
            visible: this.permissionCodes.includes(PermissionConstants.BtnWarehousingQuotation)
          }
        ]
      },
      {
        label: this.assignGenerateReceipt,
        command: (event: any) => {
          const rowData = this.table.selectedRow;
          this.showAssignModal(event, rowData);
        },
        visible: this.permissionCodes.includes(PermissionConstants.BtnWarehousingAssign)
      },
      {
        label: this.copyReciptForm,
        command: (event: any) => {
          const rowData = this.table.selectedRow;
          this.showCopyModal(event, rowData);
        },
        visible: this.permissionCodes.includes(PermissionConstants.BtnWarehousingCopy)
      },
      {
        label: this.uploadAttachment,
        command: (event: any) => {
          const rowData = this.table.selectedRow;
          this.showDofileManagement(event, rowData);
        },
        visible: this.permissionCodes.includes(PermissionConstants.BtnWarehousingUpload)
      },
      {
        label: this.warehousingDetailAbnormal,
        items: [
          {
            label: this.rfCheckedNoAd,
            command: (event: any) => {
              const rowData = this.table.selectedRow;
              this.addWarehousingAbnormalityOfRfCheckedNoAd(event, rowData);
            },
            visible: this.permissionCodes.includes(PermissionConstants.BtnWarehousingDetailAbnormal)
          },
          {
            label: this.remainingSku,
            command: (event: any) => {
              const rowData = this.table.selectedRow;
              this.validateAndOpenRemainingSkuDialog(event, rowData);
            },
            visible: this.permissionCodes.includes(PermissionConstants.BtnWarehousingDetailAbnormal)
          }
        ]
      },
    ];
    this.itemMenus.forEach(x => {
      if (x.items?.every(y => y.visible === false)) {
        x.visible = false;
      }
    });
  }

  searchDetailClick(event: any): void {
    const rowData = event.rowData;
    const isClosed = event.expanded;

    if (isClosed) {
      this.isShowDetailModal = false;
      return;
    }

    this.isShowDetailModal = true;
    this.warehousingSearchService.searchWarehousingDetail(rowData.whNo)
      .subscribe({
        next: result => {
          rowData.warehousingDetail = result;
          this.isLoading = false;
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  showAssignModal(event: any, warehousingDetail: any): void {
    this.clickWhNo = warehousingDetail.whNo;
    this.isShowAssignModal = true;
  }

  closeFile(display: boolean): void {
    this.showDoFile = display;
    this.showDoPodFile = display;
  }

  showCopyModal(event: any, warehousingDetail: any): void {
    this.clickWhNo = warehousingDetail.whNo;
    this.isShowCopyModal = true;
  }

  // 入倉單下載
  downloadWarehousing() {

    const params = deepCopy(this.searchParams);
    params.facility = this.laasSetting.facility;
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    this.warehousingSearchService.downloadWarehousing(params)
      .subscribe({
        next: result => {

          if (result == null || result.size == 0) {
            this.toastService.info(this.translateService.instant('ReceiptFormQuery.Info.NoFound'));
            this.loader.hide();
          } else {
            const file = result;
            file.name = "Warehousing";
            const url = URL.createObjectURL(file);
            let a: any = document.createElement('a');
            a.href = url
            a.download = file.name;
            a.click();
            URL.revokeObjectURL(url);
            this.loader.hide();
          }

        },
        error: (err: any) => {
          this.toastErrorMessage(err.error);
        }
      });

  }


  getsDownload() {

    const params = deepCopy(this.searchParams);
    params.facility = this.laasSetting.facility;
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    this.warehousingSearchService.getsDownload(params)
      .subscribe({
        next: result => {

          if (result == null || result.size == 0) {
            this.toastService.info(this.translateService.instant('ReceiptFormQuery.Info.NoFound'));
            this.loader.hide();
          } else {
            const file = result;
            file.name = "GE-TS REPORT";
            const url = URL.createObjectURL(file);
            let a: any = document.createElement('a');
            a.href = url
            a.download = file.name;
            a.click();
            URL.revokeObjectURL(url);
            this.loader.hide();
          }

        },
        error: (err: any) => {
          this.toastErrorMessage(err.error);
        }
      });

  }




  // 檢視入倉單
  linkClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo('/TransportOperation/WarehousingHeaderDetail', rowData, true);
  }

  // 檢視進口報關單
  importLinkClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo('/TransportOperation/ImportHeaderDetail', rowData, true);
  }

  getVendorOptions(event: any, dropdown: Dropdown): void {
    const key: string = event.filter;
    if (key != null && key.length > 1) {
      this.dropdownOptionsService.getVendorOptions(key).subscribe({
        next: (options: any[]) => {
          this.vendorOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    }
  }

  // convenience getter for easy access to form fields
  f(fg: FormGroup): any { return fg.controls; }

  changeSourceType(event: any): void {
    this.importSubmitted = false;
    let today = new Date();
    this.importForm.controls.trxDtTmp.setValue(`${today.getFullYear()}/${(today.getMonth() + 1)}/${today.getDate()}`);
    this.importForm.controls.trxAmount.setValue("");
    this.importForm.controls.brand.setValue("");
    this.importForm.controls.referenceKey.setValue([]);

    if (this.importDetailParams.sourceType == ImportSourceType.FREIGHT || this.importDetailParams.sourceType == ImportSourceType.SAMPLE) {
      this.loader.show();
      this.warehousingSearchService.referenceKeyForDetail(this.importDetailParams.whNo).subscribe({
        next: result => {
          this.importForm.controls.referenceKey.setValue([result.referenceKey]);
          if(this.importDetailParams.sourceType == ImportSourceType.SAMPLE){
            this.importForm.controls.pcsrDept.setValue("0000000000");
          }
        },
        complete: () => {
          this.loader.hide();
        }
      });
    }

  }

  openImportDetailModal(event: any, rowData: any): void {
    this.importForm.reset();
    this.importDetailParams.whNo = rowData.whNo;
    let today = new Date();
    this.importForm.controls.trxDtTmp.setValue(`${today.getFullYear()}/${(today.getMonth() + 1)}/${today.getDate()}`);
    this.isShowImportModal = true;
    this.importSubmitted = false;
    this.importEvent = {
      rowData: rowData,
      expanded: false
    };
  }

   async openBillingViewerBtn(event: any, rowData: any): Promise<void> {
    this.bookingNoFile = rowData.whNo;
    this.bookingInfo =  await this.warehousingSearchService.searchWarehousingByWhNo(rowData.whNo);
    this.warehousingSearchService.searchWarehousingDetail(rowData.whNo)
      .subscribe({
        next: result => {
          if ((result.length == 0 || result.filter((i: any) => i.referenceType == 'Advising' || i.referenceType == 'DeliveryOrder')
                                          .every((i: any) => i.whDetailStatus == 'C')) &&
            isNullOrEmpty(this.bookingInfo.brand)) {
            this.toastErrorMessage('入倉單無明細，請填寫入倉單的品牌資訊');
          }
          else if(result.length == 0 && (this.bookingInfo.deliverySubType == '3' || this.bookingInfo.deliverySubType == '2') && isNullOrEmpty(this.bookingInfo.splitDept)){
            this.toastErrorMessage('入倉單無明細，請填寫入倉單的分攤部門');
          }
          else {
            this.isShowBillingViewerModal = true;
          }
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  openBillingPreviewCalculateBtn(event: any, rowData: any): void {
    this.isShowBillingPreviewCalculateViewerModal = true;
    this.bookingNoPreviewCalculate = rowData.whNo;
  }

  closeBilling(event: any): void {
    this.isShowBillingViewerModal = false;
  }

  closeBillingPreviewCalculate(display: boolean): void {
    this.isShowBillingPreviewCalculateViewerModal = false;
  }

  displayADImportWidget(column: string): boolean {
    var specialColumn = ["pcsrDept", "brand"];
    var displayElements = ["3", "5", "6", "7", "Z", "31"];
    if (specialColumn.includes(column)) {
      displayElements = ["3", "5", "6", "7", "Z"];
    }
    return displayElements.includes(this.importDetailParams.sourceType);
  }

  async importDetailBtnClick(event: any): Promise<void> {
    this.loader.show();

    this.importSubmitted = true;

    if (this.importForm.invalid) {
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      this.loader.hide();
      return;
    }

    if (this.importDetailParams.sourceType=== "1") {
      let hawbNoVerificationResult: HawbNoVerificationResult;
      try {
        hawbNoVerificationResult = await this.warehousingSearchService.verifyHawbNoWithBillOfLadingByWhNo({
          adList: this.importDetailParams.referenceKey,
          whNo: this.importDetailParams.whNo,
        }).toPromise();
        console.info(`hawbNoVerificationResult=${JSON.stringify(hawbNoVerificationResult)}`);
        let equalStatus = hawbNoVerificationResult.equalStatus!;
        console.info(`equalStatus=${JSON.stringify(equalStatus)}`);
        if (equalStatus) {
          this.importDetail();
        } else {
          let statusCode = hawbNoVerificationResult.statusCode!;
          if (statusCode == HawbNoVerificationStatusCode.AD_NOT_FOUND_CODE) {
            this.confirmationService.confirm({
              target: event.target,
              message: `AD不存在LaaS主表，請確認是否繼續匯入？ \n (若外倉AD請繼續匯入)`,
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                this.importDetail();
              },
              reject: () => {
                this.toastService.warn(hawbNoVerificationResult.warningMessage, true);
                this.confirmationService.close();
                return;
              }
            });
          } else if ([HawbNoVerificationStatusCode.NON_UNIQUE_BILL_OF_LADING_CODE, HawbNoVerificationStatusCode.HAWB_NO_AND_BILL_OF_LADING_MISMATCH_CODE].includes(statusCode)) {
            this.confirmationService.confirm({
              target: event.target,
              message: `AD與入倉單的提單不同，請確認是否繼續匯入？`,
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                this.importDetail();
              },
              reject: () => {
                this.toastService.warn(hawbNoVerificationResult.warningMessage, true);
                this.confirmationService.close();
                return;
              }
            });
          } else {
            this.toastErrorMessage('驗證提單號執行失敗');
          }
        }
        this.loader.hide();
      } catch (error) {
        if (error instanceof HttpErrorResponse) {
          this.toastErrorMessage(error.error);
        } else {
          this.toastErrorMessage('匯入AD執行失敗');
        }
        this.loader.hide();
        return;
      }
    } else {
      this.importDetail();
    }
  }

  importDetail(): void {
    this.isLoadingImportDetail = true;
    this.loader.show();
    this.importDetailParams.trxDt = isNullOrEmpty(this.importDetailParams.trxDtTmp) ? null : new Date(this.importDetailParams.trxDtTmp).toISOString();
    this.importDetailParams.userId = this.userProfile.loginAccount;
    this.warehousingSearchService.importDetail(this.importDetailParams)
    .pipe(finalize(() => {
      this.isLoadingImportDetail = false;
    }))
    .subscribe({
      next: (result:ImportWarehousingDetailResp) => {
        this.loader.hide();
        this.isShowImportModal = false;
        this.searchDetailClick(this.importEvent);

        if(result.adList?.length > 0){
            let adMessage = ``;
            let index = 1;
            result.adList.forEach((x: any) => {
                adMessage += `${index}. ${x.referenceKey}\n`;
                index++;
            });
            this.translateService.get('ReceiptFormImport.Success', { numberOfSuccess: result.adList.length, importData: adMessage }).subscribe((translatedText: string) => {
            this.toastService.success(translatedText);
          });

        }
        console.log("failedResult:", result.failedResult);
        console.log("failedResult.failedTxnNumbers.length:", result.failedResult?.failedTxnNumbers?.length);
        console.log("result.failedResult.failedTxnNumbers.length > 0:", (result.failedResult?.failedTxnNumbers?.length ?? 0) > 0);
        if (result.failedResult?.failedTxnNumbers?.length > 0) {
          this.toastService.error(result.failedResult?.errorMessage);
        }
      },
      error: err => {
        this.loader.hide();
        if (!isNullOrEmpty(err.error.errorMsg)) {
          this.toastErrorMessage(err.error.errorMsg);
          return;
        }
        this.toastErrorMessage(err.error);
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  closeImportDetailModal(event: any): void {
    this.isShowImportModal = false;
  }


  printSelectedWarehousingPDF(): void {
    const selectedRows = this.table.selectedRows;
    if (!selectedRows || selectedRows.length === 0) {
      return;
    }
    const whNos = selectedRows.map((x: any) => x.whNo);
    this.loader.show();
    this.warehousingSearchService.printBatchWarehousingPDF(whNos)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.loader.hide())
      )
      .subscribe({
        next: result => {
          if (result == null || result.file == null) {
            this.toastService.info(this.translateService.instant('ReceiptFormQuery.Info.NoFound'));
            return;
          }
          const byteStr = atob(result.file);
          const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
          const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteStr.length; i++) {
            int8Array[i] = byteStr.charCodeAt(i);
          }
          const data: Blob = new Blob([int8Array], { type: 'application/pdf' });
          const url = URL.createObjectURL(data);
          const linkEle = document.createElement('a');
          linkEle.href = url;
          linkEle.download = 'WareHousingPrint';
          linkEle.click();
          URL.revokeObjectURL(url);
          linkEle.remove();
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  isShowDeleteIcon(rowIndex: any, rowData: any): boolean {
    return this.permissionCodes.includes(PermissionConstants.BtnDeleteWarehousingDetail) && this.table.selectedRow.whStatus !== 'C' && rowData.whDetailStatus !== 'C';
  }

  deleteBtnClick(event: any, rowIndex: any, rowData: any): void {
    this.mergeKeyService.checkAllDoInMergeKey(rowData.referenceKey).subscribe({
      next: async checkAllDoInMergeKeyResponse => {
        if (!isNullOrEmpty(checkAllDoInMergeKeyResponse.mergeKey)) {
          var instantMsg = await this.translateService.get('ReceiptFormHeaderDetails.Message.CheckAllDoInMergeKey').toPromise();
          var displayDoNoList = Array.from(new Set(checkAllDoInMergeKeyResponse.doNoList));

          console.log(displayDoNoList);
          this.confirmationService.confirm({
            target: event.target,
            message: `${laaSFormatString(instantMsg, [checkAllDoInMergeKeyResponse.mergeKey, displayDoNoList.toString()])}`,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              let deleteObjList : CancelWarehousingDetailRequest[] = [];
              for (let i = 0; i < checkAllDoInMergeKeyResponse.doNoList.length; i++) {
                if (!isNullOrEmpty(checkAllDoInMergeKeyResponse.whNoList[i])) {
                  const deleteObj: CancelWarehousingDetailRequest = {
                    whNo: checkAllDoInMergeKeyResponse.whNoList[i],
                    adNo: checkAllDoInMergeKeyResponse.doNoList[i],
                    updateUser: this.userProfile.userName,
                  };
                  deleteObjList.push(deleteObj);
                }
              }
              if (deleteObjList.length > 0) {
                this.warehousingSearchService.cancelWarehousingDetailForTaxPay(deleteObjList)
                    .subscribe({
                      next: result => {
                        rowData.whDetailStatus = 'C';
                        for (let j = 0; j < this.searchResults[rowIndex].warehousingDetail.length; j++) {

                            for (const deleteObj of deleteObjList) {
                              if (this.searchResults[rowIndex].warehousingDetail[j].referenceKey == deleteObj.adNo) {
                                this.searchResults[rowIndex].warehousingDetail[j].whDetailStatus = 'C'
                              }
                            }
                        }
                        if (this.searchResults[rowIndex].warehousingDetail.every((x: any) => x.whDetailStatus === 'C')) {
                          this.searchResults[rowIndex].whStatus = 'C';
                        }
                        this.toastService.success(this.translateService.instant('ReceiptFormQuery.Success.CancelSuccess'));
                      },
                      error: (err: HttpErrorResponse) => {
                        this.toastErrorMessage(err.error);
                      }
                    });
              }

            },
            reject: () => {
              this.confirmationService.close();
            }
          });
        } else {
          this.confirmationService.confirm({
            target: event.target,
            message: this.translateService.instant('ReceiptFormQuery.Confirm.ConfirmDelete'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              this.cancelWarehousingDetail(this.searchResults[rowIndex], rowData);
            },
            reject: () => {
              this.confirmationService.close();
            }
          });
        }
      }

    });


  }

  cancelWarehousingDetail(details: any, rowData: any): void {
    const deleteObj: CancelWarehousingDetailRequest = {
      whNo: details.whNo,
      adNo: rowData.referenceKey,
      updateUser: this.userProfile.userName,
    };
    this.warehousingSearchService.cancelWarehousingDetail(deleteObj)
      .subscribe({
        next: result => {
          this.toastService.success(this.translateService.instant('ReceiptFormQuery.Success.CancelSuccess'));
          rowData.whDetailStatus = 'C';
          if (details.warehousingDetail.every((x: any) => x.whDetailStatus === 'C')) {
            details.whStatus = 'C';
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });
  }


  closeUpdateBondedNoModal(event: any): void {
    this.isShowUpdateBondedNoModal = false;
  }

  openUpdateBondedNoModal(): void {
    this.isShowUpdateBondedNoModal = true;
  }

  fileUploader(event: any): void {
    this.warehousingSearchService.updateBondedNo(event.files[0], this.userProfile.userName).subscribe({
      next: rsp => {
        this.toastService.success(this.translateService.instant('ReceiptFormQuery.Success.UpdateSuccess'));
      },
      error: (rsp: any) => {
        const errors: string[] = rsp?.error;
        if (Array.isArray(errors) && errors.length > 0) {
          errors.forEach(msg => this.toastService.warn(msg, true));
        } else {
          this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.UpdateFail'));
        }
      },
      complete: () => {
        this.isShowUpdateBondedNoModal = false;
      }
    });
  }

  batchUpdateWHTemplateBtn(): void {

    var fileType = 'batchUpdateWH';
    var fileName = 'batchUpdateWH';

    this.commonDataService.getSystemParam(fileType).subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };
        this.dOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名
          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName + '.xlsx';
          link.click();
        });
      }
    });
  }

  exportWarehousingRMBPrice(WarehousingRMBPrice: any): void {
    const dataRows = [];
    const warehousingRMBPriceColumns = [
      { field: 'whNo', header: '入倉單號' },
      { field: 'sku', header: '料號' },
      { field: 'coo', header: '產地' },
      { field: 'unitPrice', header: '報關單價' },
      { field: 'sysPrice', header: '系統單價' },
      { field: 'isActivated', header: '是否有效' },
      { field: 'createUser', header: '建立者' },
      { field: 'createDt', header: '建立時間', dataType: 'date' },
      { field: 'updateUser', header: '更新者' },
      { field: 'updateDt', header: '更新時間', dataType: 'date' }
    ];
    for (const item of WarehousingRMBPrice) {
      const row = {} as any;
      const columns = [...warehousingRMBPriceColumns];
      for (const column of columns) {
        if (item.hasOwnProperty(column.field)) {
          let value = item[column.field];
          switch (column.field) {
            case 'isActivated':
              value = this.isActivatedOptions.find((x: any) => x.value === value)?.label;
              break;
            default:
              break;
          }
          switch (column.dataType) {
            case 'date':
              value = this.datePipe.transform(value, 'yyyy-MM-dd HH:mm:ss', this.laasSetting.facilityTimeZone);
              break;
            default:
              break;
          }
          row[column.header] = value;
        }
      }
      dataRows.push(row);
    }

    const worksheet = xlsx.utils.json_to_sheet(dataRows);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob(
      [excelBuffer],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );
    const url = URL.createObjectURL(data);
    const linkEle = document.createElement('a');
    linkEle.href = url;
    linkEle.download = 'Warehousing RMB Price Result';
    linkEle.click();
    URL.revokeObjectURL(url);
    linkEle.remove();
  }

  openImportDropShipModal(event: any, rowData: any) {
    this.importDropShipForm.reset();
    this.importDropShipParams.whNo = rowData.whNo;
    this.isShowImportDropShipModal = true;
    this.importDropShipSubmitted = false;
    this.importEvent = {
      rowData: rowData,
      expanded: false
    };
  }

  closeImportDropShipModal(event: any) {
    this.isShowImportDropShipModal = false;
  }

  importDropShipBtnClick(event: any) {
    this.importDropShipSubmitted = true;
    this.isLoadingImportDropShip = true;
    if (this.importDropShipForm.invalid) {
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      return;
    }

    this.importDropShipParams.userId = this.userProfile.loginAccount;

    this.loader.show();

    this.warehousingSearchService.importDropShip(this.importDropShipParams)
    .pipe(finalize(() => {
      this.isLoadingImportDropShip = false;
    }))
    .subscribe({
      next: result => {
        this.isShowImportDropShipModal = false;
        this.searchDetailClick(this.importEvent);

        var successMessage = `總共 ${result.length} 張成功: \n`;

        var index = 1;
        result.forEach((x: any) => {
          successMessage += `${index}. ${x}\n`;
          index++;
        });

        this.toastService.success(successMessage);
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  private downloadShippingDocuments(docType: string, referenceType: string, bookingNos: string[], remark: string): void {
    this.bookingService.downloadShippingDocuments(docType, referenceType, bookingNos, this.userProfile.loginAccount, false, remark)
      .subscribe({
        next: (results: any[]) => {
          if (results.length === 0 ||
            results[0].attachFileDetailBeans.length === 0 ||
            isNullOrEmpty(results[0].attachFileDetailBeans[0].file) ||
            isNullOrEmpty(results[0].attachFileDetailBeans[0].fileName)) {
            this.toastService.info(this.translateService.instant('ReceiptFormQuery.Info.NoFileDownload'));
            return;
          }
          const fileInfo = results[0].attachFileDetailBeans[0];
          const byteStr = atob(fileInfo.file);
          const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
          const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteStr.length; i++) {
            int8Array[i] = byteStr.charCodeAt(i);
          }
          const data: Blob = new Blob(
            [int8Array],
            { type: 'application/octet-stream' }
          );
          const url = URL.createObjectURL(data);
          const linkEle = document.createElement('a');
          linkEle.href = url;
          linkEle.download = fileInfo.fileName;
          linkEle.click();
          URL.revokeObjectURL(url);
          linkEle.remove();
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err);
        }
      });
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  importFormChipsAdd(event: any, fromControlName: any): void {
    const inputValue: string = event.value;

    const formControl = this.importForm.get(fromControlName);

    if (inputValue.includes('\r\n')) {
      const indexToRemove = formControl?.value.indexOf(inputValue);
      const targetRemovedArray = formControl?.value.slice(0, indexToRemove).concat(formControl?.value.slice(indexToRemove + 1));
      const parsedValues: string[] = inputValue.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n').map(x => x.trim());
      const concatenatedArray = targetRemovedArray.concat(parsedValues);
      const distinctArray = [...new Set(concatenatedArray)];
      formControl?.setValue(distinctArray);
    } else {
      const concatenatedArray = formControl?.value.concat(inputValue);
      const distinctArray = [...new Set(concatenatedArray)];
      formControl?.setValue(distinctArray);
    }
    console.info("formControl.value=", JSON.stringify(formControl?.value));
  }

  importDropShipFormChipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.importDropShipForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  // 附件上傳
  showDofileManagement(event: any, warehousingDetail: any): void {

    this.whNoFile = warehousingDetail.whNo;
    this.whNoFileList = [{
      doNo: warehousingDetail.whNo,
      fileType: 'Warehousing',
    }]
    if (warehousingDetail.hawbNo) {
      this.whNoFileList.push(
        {
          doNo:  warehousingDetail.hawbNo,
          fileType: 'HawbNo',
        }
      );
    }
    this.showDoFile = true;
  }

  resetBtn() {
    this.receiptFormDate.ngOnInit();
    this.receivingDate.ngOnInit();
    this.checkInDate.ngOnInit();
    this.flightDate.ngOnInit();
    this.declarationDate.ngOnInit();
    this.searchForm.reset({ facilityList: [this.laasSetting.facility] });
    this.searchParams.facilityList = [this.laasSetting.facility];
    this.searchParams.startCreateDt = null;
    this.searchParams.endCreateDt = null;
    this.searchParams.startWhDt = null;
    this.searchParams.endWhDt = null;
    this.searchParams.startRfCheckDt = null;
    this.searchParams.endRfCheckDt = null;
    this.searchParams.startFlightDt = null;
    this.searchParams.endFlightDt = null;
    this.searchParams.startImportDt = null;
    this.searchParams.endImportDt = null;
  }

  closeCopyView(event: any) {
    this.searchForm.reset({ facilityList: [this.laasSetting.facility] });

    this.searchParams.facilityList = [this.laasSetting.facility];
    this.searchParams.whNoList = [event];
    this.searchBtnClick();

  }

  dateOnChange(date: any,type:string) {
    switch(type){
      case "receiptFormDate" :
        this.searchParams.startCreateDt = date.startDate;
        this.searchParams.endCreateDt = date.endDate;
        break;
      case "receivingDate":
        this.searchParams.startWhDt = (!isNullOrEmpty(date.startDate)) ? date.startDate.setSeconds(0) : date.startDate;
        this.searchParams.endWhDt = (!isNullOrEmpty(date.endDate)) ? date.endDate.setSeconds(0) : date.endDate;
        break;
      case "checkInDate":
        this.searchParams.startRfCheckDt = date.startDate;
        this.searchParams.endRfCheckDt = date.endDate;
        break;
      case "flightDate":
        this.searchParams.startFlightDt = date.startDate;
        this.searchParams.endFlightDt = date.endDate;
        break;
      case "declarationDate":
        this.searchParams.startImportDt = date.startDate;
        this.searchParams.endImportDt = date.endDate;
        break;
    }
  }

  closeRemainingSkuDialog(event: any): void {
    console.log(`closeRemainingSkuDialog`);
    this.isShowRemainingSkuModal = false;
  }

  addWarehousingAbnormalityOfRfCheckedNoAd(event: any, rowData: any): void {
    this.confirmationService.confirm({
      target: event.target,
      message: `確認是否傳送無AD異常給PCSR？`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

        const request: AddWarehousingAbnormalRequest = {
          whNo: rowData.whNo,
          userId: this.userProfile.userName,
          abnormalType: WarehousingAbnormalType.RfCheckedNoAd,
          abnormalDetailRequests: []
        };

        this.loader.show();
        this.warehousingSearchService.addWarehousingAbnormalRecordWithValidation(request)
          .subscribe({
            next: () => {
              this.toastService.success(this.translateService.instant('ReceiptFormHeaderDetails.Message.addWarehousingAbnormalSuccess'));
              this.loader.hide();
            },
            error: (err: HttpErrorResponse) => {
              this.toastErrorMessage(err.error);
              this.loader.hide();
            }, complete: () => {
              this.loader.hide();
            }
          });
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }


  validateAndOpenRemainingSkuDialog(event: any, rowData: any): void {
    this.loader.show();
    let whNo = rowData.whNo;
    let userId = this.userProfile.userName;
    this.warehousingAbnormalService.validateBeforeExecution(whNo, userId, WarehousingAbnormalType.RemainingSku)
      .subscribe({
        next: () => {
          this.openRemainingSkuDialog(event, rowData);
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        }
      });
  }

  openRemainingSkuDialog(event: any, rowData: any): void {
    this.isShowRemainingSkuModal = true;
    console.log(`isShowRemainingSkuModal=${this.isShowRemainingSkuModal}, whno=${rowData.whNo}`);
    this.remainingSkuWhNo = rowData.whNo;
  }

  warehousingAbnormalDropdownList(): void {
    this.existedAdNoOptions = this.dropdownListYN();
    this.alreadyUploadedOptions = this.dropdownListYN();
    this.shippingProcessedRemainingOptions = this.dropdownListYN();
    this.pcsrProcessedRemainingOptions = this.dropdownListYN();
    switch (this.laasSetting.language) {
      case 'en-us':
        this.alreadynotifiedOptions = [
          { label: 'ALL', value: null },
          { label: 'no notify', value: 'X'},
          { label: 'N', value: 'N' },
          { label: 'Y', value: 'Y' }
        ];
        break;
      case 'zh-tw':
        this.alreadynotifiedOptions = [
          { label: 'ALL', value: null },
          { label: '不需通知', value: 'X'},
          { label: 'N', value: 'N' },
          { label: 'Y', value: 'Y' }
        ];
        break;
      case 'zh-cn':
        this.alreadynotifiedOptions = [
          { label: 'ALL', value: null },
          { label: '不需通知', value: 'X'},
          { label: 'N', value: 'N' },
          { label: 'Y', value: 'Y' }
        ];
    }
  }

  dropdownListYN(): any[] {
    let dropdownList: any[];
    dropdownList = [
      { label: 'ALL', value: null },
      { label: 'N', value: 'N' },
      { label: 'Y', value: 'Y' }
    ];

    // switch (this.laasSetting.language) {
    //   case 'en-us':
    //     dropdownList.unshift({
    //       label: "Please Select",
    //       value: ""
    //     })
    //     break;
    //   case 'zh-tw':
    //     dropdownList.unshift({
    //       label: "請選擇",
    //       value: ""
    //     })
    //     break;
    //   case 'zh-cn':
    //     dropdownList.unshift({
    //       label: "请选择",
    //       value: ""
    //     })
    // }
    return dropdownList;
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'facilityList':
        this.searchParams.facilityList = data;
        break;
    }
  }
}
